export const LOAD_FIRST_COVER_TO_BACKGROUND_TYPE = 'LOAD_FIRST_COVER_TO_BACKGROUND_TYPE';



// WEBPACK FOOTER //
// ./src/redux/action-types/ui/loadFirstCoverToBackgroundType.js